import Gallery from './components';

export default Gallery;
